<template>
  <v-card elevation-5 class="pa-4">
    <vue-dropzone
      :ref="dropzoneRef"
      :id="dropzoneId"
      class="dropzone"
      :options="dropzoneOptions"
      :destroyDropzone="dropzoneDestroy"
      @vdropzone-success="dropzoneSuccess"
      @vdropzone-error="dropzoneError"
      @vdropzone-mounted="dropzoneMount"
      @vdropzone-removed-file="dropzoneRemoved"
      @vdropzone-files-added="dropzoneFilesAdded"
      @vdropzone-canceled="dropzoneCanceled"
    ></vue-dropzone>
    <div class="drop-additional">
      <div class="upload-message">
        <i v-if="fileCount && !uploading"
          >Drag & drop to add more files, or <a>browse on your computer</a>.</i
        >
      </div>
      <div v-if="uploading" class="spinner">
        <v-icon>fas fa-circle-notch fa-spin</v-icon>
      </div>
    </div>
  </v-card>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.vue-dropzone {
  border-style: none;
  background-color: $amaze-blue-background;
  .dz-message {
    margin: 0;
  }
  ::v-deep .dz-file-preview {
    .dz-image {
      &:before {
        content: "\f15b"; /* file icon */
        font-family: "Font Awesome\ 5 Free";
        left: 43%;
        position: absolute;
        display: flex;
        top: 18%;
        font-size: 40px;
      }
    }
  }
}
.vue-dropzone:hover {
  background-color: #cdd7f7;
}
::v-deep .dropzone .dz-preview.dz-file-preview .dz-details,
::v-deep .dropzone .dz-preview:hover {
  z-index: 10;
}
.drop-additional {
  z-index: 1;
  // margin-top: -50px;
  display: flex;
  * {
    z-index: 1;
    pointer-events: none;
  }
  div {
    margin-top: -30px;
    padding-left: 10px;
    padding-right: 10px;
    z-index: 1;
  }
  .spinner {
    z-index: 1;
  }
  .upload-message {
    width: calc(100% - 24px);
    z-index: 1;
    font-size: smaller;
  }
}

@media (max-width: 450px) {
  .drop-additional {
    .upload-message {
      display: none;
      &:after {
        content: "+";
      }
    }
  }
}
</style>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  props: {
    "dropzone-id": {
      type: String,
      default: "myDefaultDZID"
    },
    "dropzone-ref": {
      type: String,
      default: "theDropzone"
    },
    "dropzone-destroy": {
      type: Boolean,
      default: false
    },
    "dropzone-max-files": {
      type: Number,
      default: null
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      uploading: 0,
      fileCount: 0,
      dropzoneOptions: {
        url:
          process.env.VUE_APP_API_BASE + "/userfiles?dzid=" + this.dropzoneId,
        thumbnailWidth: 150,
        maxFilesize: 1000, // MB
        maxFiles: this.dropzoneMaxFiles,
        paramName: "file",
        timeout: 180000000, // ms - 30mins
        headers: {
          Authorization: "Bearer " + this.$auth.token()
        },
        dictResponseError: "Hmm, something went wrong here...", // not working
        addRemoveLinks: true,
        dictDefaultMessage:
          "<i class='fas fa-cloud-upload-alt fa-3x'></i><h3 class='pb-0'>DRAG &amp; DROP</h3> your files, or <u>browse on your computer</u>."
      }
    };
  },
  methods: {
    dropzoneSuccess(file, response) {
      file.userfile_id = response.data.id;
      this.uploading--;
      this.fileCount++;
      this.$emit("new-userfile-id", {
        id: response.data.id,
        dzid: this.dropzoneId,
        data: response.data
      });
    },
    dropzoneFilesAdded(files, response) {
      this.uploading += files.length;
      this.$emit("dropzone-add-files", { files: files });
    },
    dropzoneCanceled() {
      this.uploading--;
      this.$emit("dropzone-canceled", this);
    },
    dropzoneError(file, response) {
      this.uploading--;
      console.error("[dropzone] Upload error", file, "response: " + response);
    },
    dropzoneMount() {
      this.$emit("dropzone-mounted", this);
    },
    dropzoneRemoved(file) {
      this.fileCount--;
      this.$emit("dropzone-removed", this);
      this.$emit("dropzone-file-removed", file.userfile_id);
      this.$emit("dropzone-remove-file", file);
    }
  }
};
</script>
